import { Box, Typography, Button, Select, MenuItem, InputLabel } from "@mui/material";
import React, { useEffect, useState } from "react"
import style from "./style";
import { ReactComponent as Download } from "../../../../../assets/AccountingModule/bill_download.svg";
import { ReactComponent as Send } from "../../../../../assets/AccountingModule/bill_send.svg";
import Modal from "../../../../../components/Modal";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { AirplaySharp } from "@mui/icons-material";

const QuoteView = ({ handleDownload, getViewInvoice, sentQuote, rowItem }) => {
  const [billHtml, setBillHtml] = useState("")
  console.log(rowItem)
  useEffect(() => {
    let isMounted = true;

    const fetchBill = async () => {
      try {
        const result = await getViewInvoice();
        console.log(result)
        if (isMounted) {
          setBillHtml(result.__html);
        }
      } catch (error) {
        console.error("Error fetching bill:", error);
      }
    };
    fetchBill();
    return () => {
      isMounted = false;
    };
  }, [getViewInvoice]);

  const handleSendInvoice = () => {
    sentQuote();
  };

  return (
    <>
      <Box sx={style.mainGrid}>
        <Typography variant="h5" sx={style.leaveHeading}>
          {"Quote Details"}
        </Typography>
        <Box sx={style.textGrid}>
          <Button
            variant="contained"
            color="success"
            sx={style.csvBtns}
            onClick={handleDownload}
          >
            <Download />
            {"Download"}
          </Button>
          <Button
            variant="contained"
            color="success"
            sx={style.checkinBtns}
            onClick={() => {
              if (rowItem.status === "Draft") {
                handleSendInvoice();
              }
            }}
          >
            <Send />
            {rowItem.status === "Published"
                ? "Publish"
                : rowItem.status === "Draft"
                  ? "Publish"
                  : rowItem.status === "Expired"
                    ? "Expired"
                    : "Unknown"}
          </Button>

        </Box>
      </Box>
      <Box sx={style.whiteSection}>
        <Box dangerouslySetInnerHTML={{ __html: billHtml }} />
      </Box>

    </>
  );
}

export default QuoteView;